import React, { useState } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import './Layout.css';

const Layout = () => {
  const { user, logout } = useApp();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="layout">
      <nav className="navbar">
        <div className="navbar-brand">
          <h1>⚖️ e-Court Management System</h1>
        </div>
        <div className="navbar-user">
          <span>Welcome, {user?.username || 'User'}</span>
          <span className="user-role">({user?.role || 'Guest'})</span>
          <button onClick={handleLogout} className="logout-btn">Logout</button>
        </div>
      </nav>

      <div className="layout-body">
        <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
          <button 
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            {sidebarOpen ? '◀' : '▶'}
          </button>
          
          <nav className="sidebar-nav">
            <Link to="/app/dashboard" className="nav-item">
              <span>📊</span> Dashboard
            </Link>

            <div className="nav-section">
              <h3>Master Modules</h3>
              <Link to="/app/master/court" className="nav-item">
                <span>📂</span> Court Master
              </Link>
              <Link to="/app/master/judge" className="nav-item">
                <span>👨‍⚖️</span> Judge Master
              </Link>
              <Link to="/app/master/advocate" className="nav-item">
                <span>👨‍💼</span> Advocate Master
              </Link>
              <Link to="/app/master/user" className="nav-item">
                <span>👤</span> User Master
              </Link>
            </div>

            <div className="nav-section">
              <h3>Case Management</h3>
              <Link to="/app/case/registration" className="nav-item">
                <span>📁</span> Case Registration
              </Link>
              <Link to="/app/case/party-details" className="nav-item">
                <span>🧑‍⚖️</span> Party Details
              </Link>
              <Link to="/app/case/advocate-mapping" className="nav-item">
                <span>🔗</span> Case-Advocate Mapping
              </Link>
            </div>

            <div className="nav-section">
              <h3>Hearing & Scheduling</h3>
              <Link to="/app/hearing/scheduling" className="nav-item">
                <span>📅</span> Hearing Scheduling
              </Link>
              <Link to="/app/hearing/proceedings" className="nav-item">
                <span>📝</span> Hearing Proceedings
              </Link>
            </div>

            <div className="nav-section">
              <h3>Documents & Judgment</h3>
              <Link to="/app/documents" className="nav-item">
                <span>📄</span> Document Management
              </Link>
              <Link to="/app/judgment" className="nav-item">
                <span>⚖️</span> Judgment & Order
              </Link>
            </div>

            <div className="nav-section">
              <h3>Other Modules</h3>
              <Link to="/app/cause-list" className="nav-item">
                <span>📋</span> Cause List
              </Link>
              <Link to="/app/case-status" className="nav-item">
                <span>🔍</span> Case Status Tracking
              </Link>
              <Link to="/app/notifications" className="nav-item">
                <span>🔔</span> Notifications
              </Link>
              <Link to="/app/reports" className="nav-item">
                <span>📊</span> Reports
              </Link>
            </div>

            {(user?.role === 'Admin' || user?.role === 'Clerk') && (
              <div className="nav-section">
                <h3>Admin</h3>
                <Link to="/app/admin" className="nav-item">
                  <span>🔐</span> Admin Panel
                </Link>
                <Link to="/app/admin/audit-logs" className="nav-item">
                  <span>📊</span> Audit Logs
                </Link>
              </div>
            )}
          </nav>
        </aside>

        <main className="main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;

